import type { ReactNode } from 'react';
import { Box } from '@mui/material';
import { useIsMobile } from '@core/hooks/useIsMobile';

export interface TwoPaneLayoutProps {
  sidebar: ReactNode;
  sidebarFooter?: ReactNode;
  /** Replaces the sidebar on mobile, rendered above the content. */
  mobileHeader?: ReactNode;
  sidebarWidth?: number;
  children: ReactNode;
}

const TwoPaneLayout = ({
  sidebar,
  sidebarFooter,
  mobileHeader,
  sidebarWidth = 240,
  children,
}: TwoPaneLayoutProps) => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {mobileHeader}
        <Box>{children}</Box>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flex: 1,
        minHeight: 0,
        border: 1,
        borderColor: 'divider',
        borderRadius: 2,
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          width: sidebarWidth,
          flexShrink: 0,
          display: 'flex',
          flexDirection: 'column',
          borderRight: 1,
          borderColor: 'divider',
        }}
      >
        <Box sx={{ flex: 1, overflow: 'auto', p: 1 }}>{sidebar}</Box>
        {sidebarFooter ? (
          <Box sx={{ p: 1, borderTop: 1, borderColor: 'divider' }}>
            {sidebarFooter}
          </Box>
        ) : null}
      </Box>
      <Box sx={{ flex: 1, minWidth: 0, overflow: 'auto', p: 2 }}>
        {children}
      </Box>
    </Box>
  );
};

export default TwoPaneLayout;
